<template>
  <div>
    <!-- <el-button v-if="!disabled" @click="openSelectModal">选择终端</el-button> -->
    <!-- 输入框 -->
    <el-input
      v-model="pageData.productLevelName"
      placeholder="选择产品系列"
      @click.native="openSelectModal"
      :disabled="disabled"
      ref="inputRef"
      readonly
    ></el-input>
    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>

<script>
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';

export default {
  components: {
    SelectConfig,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    functionCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tableData: [],
      pageData: {},
    };
  },
  methods: {
    openSelectModal() {
      const params = {
        functionCode: this.functionCode || 'product_ser_list',
        data: this.tableData || [],
        selectionList: this.tableData || [],
        idKey: 'productLevelCode',
        noReset: true,
        paramData: {
          enableStatus: '009',
        },
      };
      this.$refs.selectConfig.openSelectModal(params);
    },
    onGetSelect(e) {
      this.tableData = e || [];
      this.pageData = {
        ...this.pageData,
        tableData: this.tableData,
        productLevelCode: e && e.map((el) => el.productLevelCode).join(','),
        productLevelName: e && e.map((el) => el.productLevelName).join(','),
      };
      this.toFather();
    },
    toFather() {
      this.pageData = {
        ...this.pageData,
        tableData: this.tableData,
      };
      this.$emit('input', this.pageData);
      this.$emit('change', this.pageData);
    },
    removeEvent(row) {
      this.tableData = this.tableData.filter(
        (item) => item.productLevelCode !== row.productLevelCode,
      );
      this.toFather();
    },
    changeEvent() {
      this.pageData = {
        ...this.pageData,
        tableData: this.tableData,
      };
      this.$emit('input', this.pageData);
    },
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.tableData = val.tableData || [];
        } else {
          this.tableData = [];
        }
        this.pageData = val || {
          tableData: [],
        };
      },
    },
  },
};
</script>

<style></style>
